import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'

import Text from '../shared/text/Text'
import BaseCard from '../shared/baseCard/BaseCard'
import qbFoundationLogo from '../../assets/logos/qiibee-foundation-logo.png'
import { getContractConfig } from '../../util/app.helpers'
import TimeElapsed from '../communitySale/TimeElapsed'

const ComingSoon = ({ onCompleteCountdown }) => {
  const { t } = useTranslation()
  return (
    <Box
      sx={{
        margin: 0,
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <BaseCard sx={{ height: 340, width: 640, p: 2.8 }}>
        <Box
          display='flex'
          alignItems='center'
          justifyContent='center'
          flexDirection='column'
        >
          <img
            src={qbFoundationLogo}
            height='35px'
            width='215px'
            alt={t('home.welcome-text')}
          />
          <Text
            variant='h2'
            label={t('home.welcome-text')}
            fontWeight={900}
            fontSize='1.25rem'
            sx={{ mt: 2, mb: 0.8 }}
          />
          <Text
            label='Wen? - September 10th 2024 at 16:00 CET'
            textAlign='center'
            fontSize='1rem'
          />
          <TimeElapsed
            t={t}
            endTime={getContractConfig().start * 1000}
            sx={{ justifyContent: 'center', mt: 2.5, mb: 2.5 }}
            onComplete={onCompleteCountdown}
          />
          <Text
            label={
              <>
                <Text
                  label='Remember:'
                  color='primary.main'
                  component='span'
                  fontWeight={900}
                  fontSize='1rem'
                />{' '}
                the first 30 minutes of the Token Sale give you a 10x multiplier
                on your Deposit Points!
              </>
            }
            component='div'
            textAlign='center'
            fontSize='1rem'
          />
        </Box>
      </BaseCard>
    </Box>
  )
}

export default memo(ComingSoon)
